import React, { useEffect } from 'react';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { connect } from 'react-redux';
import Title from 'shared/components/title/Title';
import { getAssessment } from './ducks/AssessmentActions';
import InfoSection from './AssessmentSections/InfoSection';
import MovementSection from './AssessmentSections/MovementSection';
import ProgressSection from './AssessmentSections/ProgressSection';
import { getClient } from '../../ducks/clientProfileActions';
import AssessmentHead from './AssessmentSections/AssessmentHead';

const AssessmentView = ({
  assessment,
  client,
  getClient,
  getAssessment,
  ...props
}) => {
  const clientId = props.match.params.client_id;
  const assessmentId = props.match.params.id;

  useEffect(() => {
    getClient(clientId, props.history);
    getAssessment(assessmentId, props.history);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientId]);

  return (
    client &&
    assessment && (
      <div className="client-form-pages">
        <div className="container">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href={`/clients/${clientId}`}>
              {`${client?.first_name}  ${client?.last_name}`}
            </Breadcrumb.Item>
            <Breadcrumb.Item active>
              {assessment?.assessment_type
                ? assessment.assessment_type
                : 'assessment'}
            </Breadcrumb.Item>
          </Breadcrumb>

          <Title
            pageTitle={`Assessment: ${
              assessment?.assessment_type
                ? assessment.assessment_type
                : 'assessment'
            }`}
            buttonText="Edit"
            linkText="Back"
            cancelLink={`/clients/${clientId}?tab=assessments`}
            handleSubmit={() => {
              props.history.push(
                `/clients/${clientId}/assessments/${assessmentId}/edit`
              );
            }}
          />
          <div className="assessment-template">
            <AssessmentHead client={client} />
            <InfoSection assessment={assessment} />
            {assessment?.assessment_type === 'First Session' ? (
              <MovementSection assessment={assessment} />
            ) : (
              ''
            )}
            <ProgressSection assessment={assessment} />
          </div>
        </div>
      </div>
    )
  );
};

function mapStateToProps(state) {
  return {
    client: state.clientProfileReducer.client,
    assessment: state.assessmentsReducer.assessment
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getClient: (clientId, history) => dispatch(getClient(clientId, history)),
    getAssessment: (id, history) => dispatch(getAssessment(id, history))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AssessmentView);
